type TaggedFirm = {
  name: string;
  keys: Set<string>;
};

const FIRM_TAG_SELECTOR = '.legalease-display-reference[data-type="account"]';

function groupTaggedFirms(html: string): TaggedFirm[] {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const firms: TaggedFirm[] = [];

  for (const tag of doc.querySelectorAll(FIRM_TAG_SELECTOR)) {
    const name = (tag.textContent ?? "").replace(/\s+/g, " ").trim();
    if (!name) continue;
    const id = tag.getAttribute("data-id")?.trim();
    const keys = [`name:${name.toLowerCase()}`, ...(id ? [`id:${id}`] : [])];

    const firm = firms.find(f => keys.some(key => f.keys.has(key)));
    if (firm) for (const key of keys) firm.keys.add(key);
    else firms.push({ name, keys: new Set(keys) });
  }

  return firms;
}

export function findFirmTagsToConfirm(
  savedHtml: string | null | undefined,
  currentHtml: string,
): string[] {
  const current = groupTaggedFirms(currentHtml);
  if (current.length < 2) return [];
  const savedKeys = new Set(groupTaggedFirms(savedHtml ?? "").flatMap(firm => [...firm.keys]));
  const hasNewFirm = current.some(firm => ![...firm.keys].some(key => savedKeys.has(key)));
  return hasNewFirm ? current.map(firm => firm.name) : [];
}
